module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main"
  }, [_c('DataTablePage', {
    attrs: {
      "resource": "waterMeter.json",
      "title": "水表管理",
      "dialogSize": "tiny",
      "relation": false,
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "autoIndex": false,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "columns": _vm.columns
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.mapTitle,
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.showMap),
      callback: function($$v) {
        _vm.showMap = $$v
      },
      expression: "showMap"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260b1878","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/WaterMeter/index.vue
// module id = 1721
// module chunks = 1